// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__jHibB","slideTrack":"Slider_slideTrack__GzR68","sliding":"Slider_sliding__ONw1P"};